import { assets } from '#app/data/assets'

export function Logo() {
	return (
		<div className="flex shrink-0 items-center text-2xl font-medium">
			<div className="flex items-center justify-center rounded-full text-xl font-bold text-secondary">
				<img
					alt="TrueTenant Logo"
					className="h-auto max-w-[180px] object-contain md:max-w-[250px]"
					src={assets.logos.main}
				/>
			</div>
		</div>
	)
}
